module.exports = __webpack_public_path__ + "media/images/twitter-c57a998bf13eece9e54b7c4f68646a82.svg";